<template>
  <div class="question-box">
    <div class="question-title">
      <div style="display:flex;">
        <span>{{index+1}}.</span>
        <span v-html="questionContent.content"></span>
      </div>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>

    <div class="question-answer">
      <span>正确答案：</span>
      <div v-html="questionAnswer.content"></div>
    </div>
    <div class="question-answer notop" :class="isRight()">
      <div>
        <span>{{name}}的答案：</span>
        <span v-if="!fillAnswer" style="color:red;">未填写答案</span>
        <div v-html="fillAnswer"></div>
        <!-- <span class="it-li">+{{student_score}}分</span> -->
      </div>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      <div v-html="analysisContent.content"></div>
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="question-answer notop" v-if="is_read">
      <p v-if="type==='contest'">
        <span>教师评分：</span>
        <span style="color:red;">+{{student_score}}分</span>
      </p>
      <p v-if="type==='training'">
        <span>教师评分：</span>
        <el-rate :value="student_score?student_score:0" style="display:inline-block;" :disabled="true"></el-rate>
        <span style="color:#aaaeb3;">(三星为通过)</span>
      </p>
      <p v-if="remark">
        <span>教师评语：</span>
        <span>{{remark}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'currentIndex', 'name'],
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  data() {
    return {
      fillAnswer: '',//学生答案
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      questionAnswer: {},//参考答案
      remark: '',//教师评语
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
      type: this.$attrs.type,
      is_read: this.$attrs.status
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData: function () {
      this.fillAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.questionAnswer = this.itemContent.parsing.answer
      this.remark = this.itemContent.comments
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
    },
    isRight: function () {
      let cls = ''
      if (this.is_read) {
        if (this.type === 'contest') {
          if (this.student_score != this.score) {
            cls = ' is-wrong'
          } else {
            cls = ' is-right'
          }
        } else if (this.type === 'training') {
          if (this.student_score >= 3) {
            cls = ' is-right'
          } else {
            cls = ' is-wrong'
          }
        }
      }
      return cls
    }
  },
}
</script>

<style scoped="">
</style>